import { Outlet } from 'react-router-dom'

import { LegalEntityDetailRootPageDocument } from 'generated/resources/graphql'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import { useFactorialOneLayout } from 'modules/core/lib/factorial-one-layout/provider'
import legalEntities from 'modules/core/store/collections/legalEntities'

import employeeGroups from 'modules/employees/store/collections/employeeGroups'
import LegalEntityTabs from 'modules/legal_entities/components/LegalEntityTabs'
import CollectionsBootstrap from 'modules/legal_entities/lib/SettingsCollectionsBootstrap'

const RootPage = () => {
  const { id: entityId } = useStrictParams<'id'>()
  const { loading: collectionsLoading } = useAsyncData(
    () => Promise.all([employeeGroups.fetch(), legalEntities.fetch()]),
    []
  )
  const legalEntity = legalEntities.get(Number(entityId))
  const { data, loading: queryLoading, error } = useQuery(LegalEntityDetailRootPageDocument)
  const canSeeEmployees = data?.apiCore._policies.companySeeLegalEntityEmployees.can
  const { enabled: factorialOneEnabled } = useFactorialOneLayout()

  const loading = collectionsLoading || queryLoading

  const content = (
    <Outlet
      context={{
        loading,
        error: !!error,
        legalEntity,
      }}
    />
  )

  return (
    <CollectionsBootstrap>
      {factorialOneEnabled && content}
      {!factorialOneEnabled && (
        <LegalEntityTabs legalEntityId={Number(entityId)} canSeeEmployees={canSeeEmployees}>
          {content}
        </LegalEntityTabs>
      )}
    </CollectionsBootstrap>
  )
}

export default RootPage
